var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from 'react';
import './Toast.styles.scss';
import { Button } from '../Button';
import { Icon } from '../Icon';
import useScreenWidthInfo from '../_shared/hooks/useScreenWidthInfo';
var Toast = function (_a) {
    var actionOne = _a.actionOne, actionTwo = _a.actionTwo, onClose = _a.onClose, text = _a.text, _b = _a.variant, variant = _b === void 0 ? 'info' : _b, _c = _a.showIcon, showIcon = _c === void 0 ? true : _c, _d = _a.spaceToPageTop, spaceToPageTop = _d === void 0 ? 40 : _d;
    var VariantIcon;
    (function (VariantIcon) {
        VariantIcon["success"] = "CheckCircle";
        VariantIcon["warning"] = "InfoCircle";
        VariantIcon["danger"] = "CloseCircle";
    })(VariantIcon || (VariantIcon = {}));
    var hasActions = actionOne !== null && actionOne !== void 0 ? actionOne : actionTwo;
    var hasTwoActions = !!actionOne && !!actionTwo;
    var buttonsVariant = !variant || (variant && ['danger', 'info'].includes(variant))
        ? 'neutral-inverse'
        : 'neutral';
    var toastRef = useRef(null);
    var closeToast = function () {
        var _a;
        (_a = toastRef.current) === null || _a === void 0 ? void 0 : _a.classList.add('close-toast');
        setTimeout(function () {
            var _a;
            (_a = toastRef.current) === null || _a === void 0 ? void 0 : _a.classList.remove('close-toast');
            onClose();
        }, 250);
    };
    var getToastClassName = function () {
        var classList = ['hefesto-toast'];
        if (variant) {
            classList.push("hefesto-toast--".concat(variant));
        }
        return classList.join(' ');
    };
    var toastClassName = getToastClassName();
    var getToastContentClassName = function () {
        var classList = ['hefesto-toast__content'];
        if (hasTwoActions) {
            classList.push('hefesto-toast__content--two-actions');
        }
        return classList.join(' ');
    };
    var toastContentClassName = getToastContentClassName();
    var getToastIconClassName = function () {
        var classList = ['hefesto-toast__icon'];
        if (hasTwoActions) {
            classList.push('hefesto-toast__icon--two-actions');
        }
        return classList.join(' ');
    };
    var toastIconClassName = getToastIconClassName();
    var isSmallerThanLayoutWidthSM = useScreenWidthInfo().isSmallerThanLayoutWidthSM;
    return (_jsx("div", __assign({ className: toastClassName, style: { top: spaceToPageTop }, "data-testid": "hefesto-toast", ref: toastRef }, { children: _jsxs("div", __assign({ className: "hefesto-toast__container" }, { children: [showIcon && !!variant && variant !== 'info' && (_jsx("i", __assign({ className: toastIconClassName }, { children: !!variant && (_jsx(Icon, { option: VariantIcon[variant], size: hasTwoActions && isSmallerThanLayoutWidthSM ? 'md' : 'sm' })) }))), _jsxs("div", __assign({ className: toastContentClassName }, { children: [_jsx("span", __assign({ className: "hefesto-toast__text" }, { children: text })), hasActions && (_jsxs("div", __assign({ className: "hefesto-toast__actions" }, { children: [!!actionOne && (_jsx(Button, __assign({ name: actionOne.label, variant: buttonsVariant, onClick: function () {
                                        actionOne.onClick();
                                        closeToast();
                                    } }, { children: actionOne.label }))), !!actionTwo && (_jsx(Button, __assign({ name: actionTwo.label, variant: buttonsVariant, onClick: function () {
                                        actionTwo.onClick();
                                        closeToast();
                                    } }, { children: actionTwo.label })))] }))), !hasActions && (_jsx("div", __assign({ className: "hefesto-toast__close-action" }, { children: _jsx(Button, { name: "close-btn", variant: buttonsVariant, onClick: closeToast, icon: _jsx(Icon, { option: "X" }) }) })))] }))] })) })));
};
export default Toast;
